export default async function swrFetch(...args) {
  const res = await fetch(...args)
  return await res.json()
}
